export default __webpack_public_path__ + "static/media/APACHE RR 310_3.548ab88d.webp";